/* NOWADAYS: Produktblöcke auf der Startseite auf PDP-Layout bringen */
(function(){
  if (!document.body.classList.contains('template-index')) return;

  function trustHtml(){
    return '<div class="nd-trust">'
      + '<div><span data-nd-ship>Versand mit DHL aus Hamburg</span></div>'
      + '<div><span>Kostenloser Versand mit <strong>DHL</strong> · Lieferung in 1–3 Werktagen</span></div>'
      + '<div><span>Kostenlose Rücksendung innerhalb von 30 Tagen</span></div>'
      + '</div>';
  }
  function startCountdown(el){
    function berlinNow(){ return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' })); }
    function upd(){
      var now = berlinNow(), day = now.getDay();
      var cut = new Date(now.getTime()); cut.setHours(15,0,0,0);
      if (day >= 1 && day <= 5 && now < cut) {
        var mins = Math.ceil((cut - now) / 60000), h = Math.floor(mins/60), m = mins%60;
        el.innerHTML = 'Bestell innerhalb von <strong>' + (h>0 ? h+' Std. ' : '') + m + ' Min.</strong> – geht in der Regel noch heute raus';
      } else {
        el.innerHTML = 'Jetzt bestellen – geht <strong>' + ((day===5||day===6||day===0) ? 'am Montag' : 'morgen') + '</strong> raus';
      }
    }
    upd(); setInterval(upd, 30000);
  }
  function hideOldTrust(scope){
    var t = null;
    scope.querySelectorAll('div,ul').forEach(function(el){
      var x = el.textContent || '';
      if (x.indexOf('Free shipping within Germany') > -1 && x.indexOf('Free returns') > -1
          && !el.querySelector('button') && !el.querySelector('.nd-buybox') && !el.querySelector('.nd-trust')) {
        if (!t || t.contains(el)) t = el;
      }
    });
    if (t) t.style.display = 'none';
  }

  function optionIndexes(p){
    var names = (p.options || []).map(function(o){ return (typeof o === 'string' ? o : o.name) || ''; });
    var ci = -1, si = -1;
    names.forEach(function(n, i){
      var l = n.toLowerCase();
      if (l === 'color' || l === 'colour' || l === 'farbe') ci = i;
      if (l === 'size' || l === 'größe' || l === 'grosse') si = i;
    });
    return { ci: ci, si: si };
  }

  function build(area, p){
    if (area.querySelector('.nd-buybox')) return;
    var form = area.querySelector('.product-detail__form');
    var action = area.querySelector('.product-detail__form__action');
    var idInput = area.querySelector('input[name="id"]');
    if (!form || !action || !idInput) return;

    var ix = optionIndexes(p);
    var curId = parseInt(idInput.value, 10);
    var cur = p.variants.filter(function(v){ return v.id === curId; })[0] || p.variants[0];
    if (!cur) return;
    var colorName = ix.ci > -1 ? cur.options[ix.ci] : '';

    var box = document.createElement('div');
    box.className = 'nd-buybox';
    var html = '';
    if (colorName) html += '<p class="nd-label">Farbe: <strong>' + colorName + '</strong></p><div class="nd-colors"></div>';
    if (ix.si > -1) {
      var sizes = p.variants.filter(function(v){
        if (v.options[ix.si] === 'TBC') return false;
        return ix.ci > -1 ? v.options[ix.ci] === colorName : true;
      });
      var sold = [];
      html += '<div class="nd-size-head"><span class="nd-label">Größe</span>'
            + '<a class="nd-size-guide" href="/pages/kopie-von-size-guide" target="_blank" rel="noopener">Größentabelle</a></div>'
            + '<div class="nd-sizes">';
      sizes.forEach(function(v){
        var s = v.options[ix.si];
        if (!v.available) sold.push(s);
        html += '<button type="button" class="nd-size' + (v.id === cur.id ? ' is-active' : '')
              + (v.available ? '' : ' is-soldout') + '" data-vid="' + v.id + '"'
              + (v.available ? '' : ' disabled') + '>' + s + '</button>';
      });
      html += '</div><p class="nd-model">Model trägt M, 185 cm'
            + (sold.length ? ' · ' + sold.join(', ') + ' ausverkauft' : '') + '</p>';
    }
    box.innerHTML = html;
    action.parentNode.insertBefore(box, action);

    box.querySelectorAll('.nd-size').forEach(function(b){
      b.addEventListener('click', function(){
        if (b.disabled) return;
        box.querySelectorAll('.nd-size').forEach(function(x){ x.classList.remove('is-active'); });
        b.classList.add('is-active');
        area.querySelectorAll('input[name="id"]').forEach(function(i){ i.value = b.getAttribute('data-vid'); });
      });
    });

    var wrap = document.createElement('div');
    wrap.innerHTML = trustHtml();
    var trust = wrap.firstChild;
    action.parentNode.insertBefore(trust, action.nextSibling);
    startCountdown(trust.querySelector('[data-nd-ship]'));

    var q = area.querySelector('.quantity-wrapper');
    if (q) q.style.display = 'none';
    hideOldTrust(form);
    area.querySelectorAll('button[name="add"]').forEach(function(b){
      if (!b.disabled) b.textContent = 'In den Warenkorb';
    });
  }

  function init(area){
    var link = area.querySelector('a.product-area__details__title');
    if (!link) return;
    var url = link.getAttribute('href');
    if (!url) return;
    fetch(url.split('?')[0] + '.js')
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){ if (p && p.variants) build(area, p); })
      .catch(function(){});
  }

  function run(){ document.querySelectorAll('.section-featured-product .product-area').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
})();